import e from"./_freeGlobal.js";var t=e,f="object"==typeof self&&self&&self.Object===Object&&self,l=t||f||Function("return this")();export{l as default};
//# sourceMappingURL=_root.js.map
